import api from 'service/api'

const dponetAPI = api.create('dponet')

const exportReport = async ({ ...params }) => {
  return await dponetAPI.post('/cookie_tags/export_report', params)
}

export default { exportReport }
